export default __webpack_public_path__ + "static/media/spd-bbc-img.1a5dafee.webp";